<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12">
    <app-select-form-field
      formControlName="caseStage"
      [users]="false"
      [label]="'case.fields.caseStage.label' | translate"
      [helpText]="'case.fields.caseStage.help'"
      [items]="caseStageItems"
      [viewMode]="viewMode"
      [bindValue]="'value'"
      [customClass]="'case-right-section'"
      (onSelectEvent)="onChangeCaseStage($event)"
    ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-status-select-field
      [hidden]="
        this.form.get('caseStage').value === caseStatusEnum.CLOSED_RESOLVED
        || this.form.get('caseStage').value === caseStatusEnum.CLOSED_NOT_RESOLVED
      "
      formControlName="nextActionStatus"
      [label]="'case.fields.nextActionStatus.label' | translate"
      [helpText]="'case.fields.nextActionStatus.help'"
      [items]="actionStatusItems"
      [bindValue]="'value'"
      [customClass]="'case-right-section'"
      [itemClass]="form.get('nextActionStatus')?.value"
      (onSelectEvent)="changeNextActionStatus($event)"
    ></app-status-select-field>

  </div>
  <div class="col-12">
    <app-select-form-field
      formControlName="nextActionOwnerId"
      [label]="'case.fields.nextActionOwnerId.label' | translate"
      [helpText]="'case.fields.nextActionOwnerId.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="nextActionOwnerUsers"
      [bindValue]="'id'"
      [bindLabel]="'fullName'"
      [viewMode]="viewMode"
      [isRequired]="nextActionValidators"
      [externalSearch]="true"
      (onSearchEvent)="searchUsers('search', $event.term, 'nextActionOwnerUsers', $event.page, $event.take)"
      (onScrollEvent)="searchUsers('scroll', $event.term, 'nextActionOwnerUsers', $event.page, $event.take)"
    ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-datepicker-form-field
      formControlName="nextActionDueDate"
      [label]="'case.fields.nextActionDueDate.label' | translate"
      [helpText]="'case.fields.nextActionDueDate.help'"
      [viewMode]="viewMode"
      [minDate]="nextActionValidators ? today : undefined"
      [isRequired]="nextActionValidators"
      [highlightClass]="getColorOfNextActionDueDate(form.get('nextActionDueDate').value)"
  ></app-datepicker-form-field>
  </div>
  <div class="col-12">
    <app-textarea-form-field
      formControlName="nextActionDescription"
      [label]="'case.fields.nextActionDescription.label' | translate"
      [helpText]="'case.fields.nextActionDescription.help'"
      [viewMode]="viewMode"
      [isRequired]="nextActionValidators"
    ></app-textarea-form-field>
  </div>
</div>
